export const STATUS_STYLES = {
    'Approved': 'primary',
    'Accepted': 'primary',
    'Awaiting Review': 'secondary',
    'Awaiting Approval': 'secondary',
    'Change Requested': 'warning-subtle'
};
